export default {
  title: 'Signature preview',
  setupInstruction: `
      <h3>Basic usage:</h3>
      <p>Click on "Copy as HTML" button and paste snippet of your signature into your email client settings.</p>
      <h3>Advance usage:</h3>
      <p>For some email clients, like gmail, you may using simply copy/paste highlight selection. Click on "Copy as Select" button and paste of your signature into your email client settings.</p>
    `,
  viewSource: {
    title: 'Your email signature',
    description: 'Copy the HTML code below and paste it to your signature file'
  },
  moreTemplate: 'Soon more template',
  selectTemplate: 'Select template'
};
